import React, { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    CalendarOutlined,
    SafetyOutlined,
    CrownOutlined,
    LineChartOutlined,
    CreditCardOutlined,
    FileTextOutlined,
    UploadOutlined,
    ClockCircleOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import {
    capitalizeFirstLetter,
    formatDateTime,
} from "../../../../utils/functions";
import SOURCES from "../../../../utils/constants";
import usePost from "../../../../services/usePost";
import { Col, Row, Select, Tag } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";
import CommonDatePicker from "../../../global/datePicker";
import CommonDialog from "../../../global/dialog";

const EnhanceUserDetails = ({
    leadDetail,
    userInfo,
    setUserInfo,
    paymentPlans,
    loginAsUser,
    deleteUser,
    removeSuccess,
    getUsers,
    setshowDeatail,
    getBadgeColor,
}) => {
    const [loading, setLoading] = useState(false);
    const [trialPeriod, setTrialPeriod] = useState("");
    const [activateTill, setActivateTill] = useState("");
    const [userSettings, setUserSettings] = useState({
        settingKey: "MAX_LEADS_UPLOAD_VIA_CSV",
        settingValue: "",
    });

    const [toggleModalOptions, setToggleModalOptions] = useState({
        showModal: false,
        title: "",
        postMessage: "",
        actionMethod: "",
        type: "",
    });

    console.log("leadDetail", leadDetail);

    const { callApi: changeUserPaymentPlan, processSuccess: paymentPlanSuccess } =
        usePost({
            endpoint: `admin/change-user-plan`,
        });

    const { callApi: changeUserTrialPeriod, processSuccess: trialPeriodSuccess } =
        usePost({
            endpoint: `admin/change-user-trial-period`,
        });

    const { callApi: changeVerificationCode, processSuccess: resendSuccess } =
        usePost({
            endpoint: `admin/resent-verification-code`,
        });

    const { callApi: updateUserSettings, processSuccess: maxLeadsUploadSuccess } =
        usePost({
            endpoint: `user/settings`,
        });

    const {
        callApi: reactivateAccount,
        processSuccess: reavtivateAcountSuccess,
    } = usePost({
        endpoint: `admin/reactivate-account`,
    });

    useEffect(() => {
        if (
            resendSuccess ||
            paymentPlanSuccess ||
            trialPeriodSuccess ||
            maxLeadsUploadSuccess ||
            reavtivateAcountSuccess
        )
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    }, [
        resendSuccess,
        paymentPlanSuccess,
        trialPeriodSuccess,
        maxLeadsUploadSuccess,
        reavtivateAcountSuccess,
    ]);

    const setSettings = () => {
        if (leadDetail?.UserSettings?.length > 0) {
            leadDetail?.UserSettings?.map((setting) => {
                setUserSettings((prevState) => ({
                    ...prevState,
                    settingValue: setting.settingValue,
                }));
            });
        } else {
            setUserSettings((prevState) => ({
                ...prevState,
                settingValue: "",
            }));
        }
    };

    useEffect(() => {
        setSettings();
    }, [leadDetail]);

    useEffect(() => {
        if (removeSuccess) {
            setToggleModalOptions({
                ...toggleModalOptions,
                showModal: false,
            });
            setshowDeatail(false);
            getUsers();
        }
    }, [removeSuccess]);

    const resendVerificationCode = async () => {
        const res = await changeVerificationCode({ email: leadDetail.email });
        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const changeUserPayment = async () => {
        const res = await changeUserPaymentPlan(
            {
                email: leadDetail.email,
                paymentPlanId: userInfo.plan,
            },
            "Payment plan changed successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const changeUserTrial = async () => {
        const res = await changeUserTrialPeriod(
            {
                email: leadDetail.email,
                trialPeriod,
            },
            "Trial period changed successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const saveUserSettings = async () => {
        const res = await updateUserSettings(
            {
                userId: leadDetail._id,
                settings: [userSettings],
            },
            "Settings updated successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const saveReactivateAccount = async () => {
        const res = await reactivateAccount(
            {
                email: leadDetail.email,
                reactivatedTillDate: activateTill,
            },
            "Account reactivated successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    if (!leadDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            Name: <UserOutlined />,
            Email: <MailOutlined />,
            Phone: <PhoneOutlined />,
            Company: <BankOutlined />,
            "Registered On": <CalendarOutlined />,
            Verified: <SafetyOutlined />,
            Role: <CrownOutlined />,
            Status: <LineChartOutlined />,
            "Trial Period": <ClockCircleOutlined />,
            "Trial Ended At": <CalendarOutlined />,
            "Payment Status": <CreditCardOutlined />,
            "Current Plan": <FileTextOutlined />,
            "CSV Leads Upload Limit": <UploadOutlined />,
        };
        return iconMap[label] || <FileTextOutlined />;
    };

    return (
        <>
            <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
                <Row gutter={[24, 24]}>
                    <Col span={12}>
                        <CommonCard
                            title={
                                <div className="flex items-center gap-2">
                                    <UserOutlined
                                        style={{
                                            color: "var(--primary-color, #1890ff)",
                                            fontSize: "18px",
                                        }}
                                    />
                                    <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                        Basic Details
                                    </span>
                                </div>
                            }
                        >
                            <Row>
                                {[
                                    {
                                        label: "Name",
                                        value: leadDetail?.name,
                                    },
                                    {
                                        label: "Email",
                                        value: leadDetail?.email,
                                    },
                                    {
                                        label: "Phone",
                                        value: leadDetail?.phone,
                                    },
                                    {
                                        label: "Company",
                                        value: leadDetail?.company,
                                    },
                                    {
                                        label: "Registered On",
                                        value: formatDateTime(leadDetail?.createdAt),
                                    },
                                ].map((item, idx) => (
                                    <Col
                                        span={24}
                                        key={item.label}
                                        className={cn(
                                            "border-b border-gray-200 py-4",
                                            idx === 4 && "!border-b-0"
                                        )}
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                                <span
                                                    style={{
                                                        color: "var(--primary-color, #1890ff)",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {getIconForField(item.label)}
                                                </span>
                                                {item.label}
                                            </span>
                                            <span className="text-sm font-semibold text-gray-900">
                                                {item.value || "—"}
                                            </span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </CommonCard>
                    </Col>

                    <Col span={12}>
                        <CommonCard
                            title={
                                <div className="flex items-center gap-2">
                                    <SafetyOutlined
                                        style={{
                                            color: "var(--primary-color, #1890ff)",
                                            fontSize: "18px",
                                        }}
                                    />
                                    <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                        Verification Details
                                    </span>
                                </div>
                            }
                        >
                            <Row>
                                {[
                                    {
                                        label: "Verified",
                                        value: leadDetail?.verified === "Verified" ? "Yes" : "No",
                                        color: leadDetail?.verifiedBadge?.color,
                                    },
                                    {
                                        label: "Role",
                                        value: leadDetail?.userRole,
                                        color: "primary",
                                    },
                                    {
                                        label: "Status",
                                        value: leadDetail?.statusBadge.text,
                                        color: leadDetail?.statusBadge.color,
                                    },
                                ].map((item, idx) => (
                                    <Col
                                        span={24}
                                        key={item.label}
                                        className={cn(
                                            "border-b border-gray-200 py-4",
                                            idx === 2 && "!border-b-0"
                                        )}
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                                <span
                                                    style={{
                                                        color: "var(--primary-color, #1890ff)",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {getIconForField(item.label)}
                                                </span>
                                                {item.label}
                                            </span>
                                            <Tag
                                                color={getBadgeColor(item)}
                                                className="m-0 px-3 py-1 font-medium"
                                            >
                                                {item.value}
                                            </Tag>
                                        </div>
                                    </Col>
                                ))}
                                <Button
                                    color={
                                        leadDetail?.verified === "Not Verified"
                                            ? "primary"
                                            : "secondary"
                                    }
                                    className={cn(
                                        "mt-5 w-100 d-flex align-items-center justify-content-center gap-2 py-2",
                                        leadDetail?.verified !== "Not Verified"
                                            ? "bg-gray-100 text-gray-400 border-gray-200"
                                            : "w-full flex items-center justify-center gap-x-2 border !border-primary !text-primary bg-transparent hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
                                    )}
                                    disabled={leadDetail?.verified !== "Not Verified"}
                                    onClick={() => {
                                        setToggleModalOptions({
                                            ...toggleModalOptions,
                                            showModal: true,
                                            title: "Resend Verification Code",
                                            postMessage:
                                                "Are you sure you want to Resend Verification Code?",
                                            actionMethod: () => resendVerificationCode(),
                                            type: "RESEND_VERIFICATION_CODE",
                                        });
                                    }}
                                >
                                    <SyncOutlined style={{ fontSize: "16px" }} />
                                    Resend Verification Code
                                </Button>
                            </Row>
                        </CommonCard>
                    </Col>
                </Row>

                {leadDetail?.userRole !== SOURCES.USER_ROLE_ADMIN && (
                    <Row gutter={[24, 24]} className="mt-6">
                        <Col span={12}>
                            <CommonCard
                                title={
                                    <div className="flex items-center gap-2">
                                        <ClockCircleOutlined
                                            style={{
                                                color: "var(--primary-color, #1890ff)",
                                                fontSize: "18px",
                                            }}
                                        />
                                        <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                            Trial Period
                                        </span>
                                    </div>
                                }
                            >
                                <Row>
                                    {[
                                        {
                                            label: "Trial Period",
                                            value: leadDetail?.isTrial === "y" ? "Yes" : "No",
                                            color: leadDetail?.trialBadge.color,
                                            isBadge: true,
                                        },
                                        {
                                            label: "Trial Ended At",
                                            value:
                                                (leadDetail?.userStatus ===
                                                    SOURCES.USER_STATUS_TRIAL_END ||
                                                    leadDetail?.userStatus ===
                                                    SOURCES.USER_STATUS_TRIAL) &&
                                                formatDateTime(leadDetail?.updatedAt, "MMM Do YY"),
                                        },
                                        {
                                            label: "Change Trial Period",
                                            value: (
                                                <CommonDatePicker
                                                    onChange={(date, dateString) => {
                                                        setTrialPeriod(date);
                                                    }}
                                                    value={trialPeriod}
                                                    className="!h-10 w-full"
                                                />
                                            ),
                                        },
                                    ].map((item, idx) => (
                                        <Col
                                            span={24}
                                            key={item.label}
                                            className={cn(
                                                "border-b border-gray-200 py-4",
                                                idx === 2 && "!border-b-0"
                                            )}
                                        >
                                            <div className="flex justify-between items-center w-full">
                                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                                    <span
                                                        style={{
                                                            color: "var(--primary-color, #1890ff)",
                                                            fontSize: "16px",
                                                        }}
                                                    >
                                                        {getIconForField(item.label)}
                                                    </span>
                                                    {item.label}
                                                </span>
                                                {item.isBadge ? (
                                                    <Tag
                                                        color={getBadgeColor(item)}
                                                        className="m-0 px-3 py-1 font-medium"
                                                    >
                                                        {item.value}
                                                    </Tag>
                                                ) : (
                                                    <span className="text-sm font-semibold text-gray-900">
                                                        {item.value || "—"}
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                    ))}
                                    <Button
                                        color="primary"
                                        className="mt-5 w-full flex items-center justify-center gap-x-2 border !border-primary !text-primary bg-transparent hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
                                        onClick={() => {
                                            setToggleModalOptions({
                                                ...toggleModalOptions,
                                                showModal: true,
                                                title: "Update Trial Period",
                                                postMessage:
                                                    "Are you sure you want to Update Trial Period?",
                                                actionMethod: () => changeUserTrial(),
                                                type: "UPDATE_TRIAL_PERIOD",
                                            });
                                        }}
                                    >
                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                        Update Trial Period
                                    </Button>
                                </Row>
                            </CommonCard>
                        </Col>

                        <Col span={12}>
                            <CommonCard
                                title={
                                    <div className="flex items-center gap-2">
                                        <CreditCardOutlined
                                            style={{
                                                color: "var(--primary-color, #1890ff)",
                                                fontSize: "18px",
                                            }}
                                        />
                                        <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                            Payment Details
                                        </span>
                                    </div>
                                }
                            >
                                <Row>
                                    {[
                                        {
                                            label: "Payment Status",
                                            value: leadDetail?.paymentStatus ? "Paid" : "Not Paid",
                                            color: leadDetail?.paymentStatus ? "success" : "danger",
                                        },
                                        {
                                            label: "Current Plan",
                                            value:
                                                leadDetail?.PlanInformation?.planName ||
                                                leadDetail?.PlanInformation[0]?.planName,
                                            color: "primary",
                                        },
                                        {
                                            label: "Change Plan",
                                            isSelect: true,
                                            value: (
                                                <Select
                                                    options={SOURCES.getPaymentPlans(paymentPlans)}
                                                    value={userInfo?.plan}
                                                    onChange={(value) =>
                                                        setUserInfo({
                                                            ...userInfo,
                                                            plan: value,
                                                        })
                                                    }
                                                    placeholder="Select Plan"
                                                    className="h-10 w-full !outline-none"
                                                    style={{ maxWidth: "200px" }}
                                                />
                                            ),
                                        },
                                    ].map((item, idx) => (
                                        <Col
                                            span={24}
                                            key={item.label}
                                            className={cn(
                                                "border-b border-gray-200 py-4",
                                                idx === 2 && "!border-b-0"
                                            )}
                                        >
                                            <div className="flex justify-between items-center w-full">
                                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                                    <span
                                                        style={{
                                                            color: "var(--primary-color, #1890ff)",
                                                            fontSize: "16px",
                                                        }}
                                                    >
                                                        {getIconForField(item.label)}
                                                    </span>
                                                    {item.label}
                                                </span>
                                                {item.isSelect ? (
                                                    item.value
                                                ) : (
                                                    <Tag
                                                        color={getBadgeColor(item)}
                                                        className="m-0 px-3 py-1 font-medium"
                                                    >
                                                        {item.value}
                                                    </Tag>
                                                )}
                                            </div>
                                        </Col>
                                    ))}
                                    <Button
                                        color="primary"
                                        className="mt-5 w-full flex items-center justify-center gap-x-2 border !border-primary !text-primary bg-transparent hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
                                        onClick={() => {
                                            setToggleModalOptions({
                                                ...toggleModalOptions,
                                                showModal: true,
                                                title: "Update Payment Plan",
                                                postMessage:
                                                    "Are you sure you want to Update Payment Plan?",
                                                actionMethod: () => changeUserPayment(),
                                                type: "UPDATE_PAYMENT_PLAN",
                                            });
                                        }}
                                    >
                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                        Update Payment Plan
                                    </Button>
                                </Row>
                            </CommonCard>
                        </Col>

                        <Col span={12}>
                            <CommonCard
                                title={
                                    <div className="flex items-center gap-2">
                                        <SettingOutlined
                                            style={{
                                                color: "var(--primary-color, #1890ff)",
                                                fontSize: "18px",
                                            }}
                                        />
                                        <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                            Settings
                                        </span>
                                    </div>
                                }
                            >
                                <Row>
                                    {[
                                        {
                                            label: "CSV Leads Upload Limit",
                                            value: (
                                                <Input
                                                    placeholder="Enter CSV Leads Upload Limit"
                                                    type="number"
                                                    value={userSettings?.settingValue}
                                                    onChange={(e) =>
                                                        setUserSettings({
                                                            ...userSettings,
                                                            settingValue: e.target.value,
                                                        })
                                                    }
                                                    className="h-10 !w-full border !border-primary !text-primary bg-transparent hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
                                                />
                                            ),
                                        },
                                    ].map((item) => (
                                        <Col span={24} key={item.label} className="py-4">
                                            <div className="flex flex-col gap-3 w-full">
                                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                                    <span
                                                        style={{
                                                            color: "var(--primary-color, #1890ff)",
                                                            fontSize: "16px",
                                                        }}
                                                    >
                                                        {getIconForField(item.label)}
                                                    </span>
                                                    {item.label}
                                                </span>
                                                <div className="w-full">{item.value}</div>
                                            </div>
                                        </Col>
                                    ))}
                                    <Button
                                        color="primary"
                                        className="mt-3 w-full flex items-center justify-center gap-x-2 border !border-primary !text-primary bg-transparent hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
                                        onClick={() => {
                                            setToggleModalOptions({
                                                ...toggleModalOptions,
                                                showModal: true,
                                                title: "Update Settings",
                                                postMessage:
                                                    "Are you sure you want to Update Settings?",
                                                actionMethod: () => saveUserSettings(),
                                                type: "UPDATE_SETTINGS",
                                            });
                                        }}
                                    >
                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                        Update Settings
                                    </Button>
                                </Row>
                            </CommonCard>
                        </Col>
                    </Row>
                )}
            </div>
            {toggleModalOptions?.showModal && (
                <CommonDialog
                    title={toggleModalOptions?.title}
                    description={toggleModalOptions?.postMessage}
                    onOk={async () => {
                        setLoading(true);
                        await toggleModalOptions?.actionMethod();
                        setLoading(false);
                        if (toggleModalOptions?.type !== "RESEND_VERIFICATION_CODE") {
                            getUsers();
                        }
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false });
                    }}
                    onCancel={() =>
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false })
                    }
                    open={toggleModalOptions?.showModal}
                    setOpen={() =>
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false })
                    }
                    isConfirmButtonLoading={loading}
                />
            )}
        </>
    );
};

export default EnhanceUserDetails;
